import type { BrandTwoLetterCode } from "brandRegionConfig";
import type { Brand } from "core/entities";
import { CREThemeOptions } from "core/theme/CRETheme";
import { FixAutoThemeOptions } from "core/theme/FixAutoTheme";
import { FixNationRestorationTheme } from "core/theme/FixNationRestorationTheme";
import { NovusCrystalGlassThemeOptions } from "core/theme/NovusCrystalGlassTheme";
import { NovusGlassThemeOptions } from "core/theme/NovusGlassTheme";
import { ProColorThemeOptions } from "core/theme/ProColorTheme";
import { SpeedyAutoThemeOptions } from "core/theme/SpeedyAutoTheme";
import { SpeedyGlassThemeOptions } from "core/theme/SpeedyGlassTheme";

export const BrandMap = new Map<BrandTwoLetterCode, Brand>();

BrandMap.set("NG", {
  brandClassification: "Glass",
  brandCode: "novusglass",
  brandTwoLetterCode: "NG",
  themeOptions: NovusGlassThemeOptions,
});

BrandMap.set("NC", {
  brandClassification: "Glass",
  brandCode: "crystalglass",
  brandTwoLetterCode: "NC",
  themeOptions: NovusCrystalGlassThemeOptions,
});

BrandMap.set("SA", {
  brandClassification: "Mechanical",
  brandCode: "speedyauto",
  brandTwoLetterCode: "SA",
  themeOptions: SpeedyAutoThemeOptions,
});

BrandMap.set("SG", {
  brandClassification: "Glass",
  brandCode: "speedyglass",
  brandTwoLetterCode: "SG",
  themeOptions: SpeedyGlassThemeOptions,
});

BrandMap.set("FA", {
  brandClassification: "Collision",
  brandCode: "fixaut",
  brandTwoLetterCode: "FA",
  themeOptions: FixAutoThemeOptions,
});

BrandMap.set("PC", {
  brandClassification: "Collision",
  brandCode: "proc",
  brandTwoLetterCode: "PC",
  themeOptions: ProColorThemeOptions,
});

BrandMap.set("CR", {
  brandClassification: "Collision",
  brandCode: "cre",
  brandTwoLetterCode: "CR",
  themeOptions: CREThemeOptions,
});

BrandMap.set("NR", {
  brandCode: "nationrestoration",
  brandTwoLetterCode: "NR",
  themeOptions: FixNationRestorationTheme,
  brandClassification: "Home",
});

// Hostnames and asset paths still use the legacy brand short name.
export function getBrandByCode(brandCode: string): Brand | undefined {
  return Array.from(BrandMap.values()).find(
    (brand) => brand.brandCode === brandCode
  );
}

export default BrandMap;
